import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  padding: ${space['space-300']} 0;
`;

export const IconWrapper = styled.span<{ $variant?: 'info' | 'warning' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => (p.$variant === 'warning' ? semantic.text.danger : semantic.text.secondary)};
  flex-shrink: 0;
`;

export const NoteText = styled.span<{ $variant?: 'info' | 'warning' }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${(p) => (p.$variant === 'warning' ? semantic.text.danger : semantic.text.secondary)};
`;
